import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { BusinessPartnerService } from '../../business-partners/business-partner/business-partner.service';
import BusinessPartnerAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { getCode } from 'app/utils/method';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@ngneat/transloco';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { GeoComponent } from './exports/geo.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BusinessPartnerAddressService } from '../../business-partners/business-partner/business-partner-address-modal/business-partner-address.component.service';
import { Workbook } from 'exceljs';
import { PreviewExcelModalComponent } from './exports/preview-excel.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { FilterSectionComponent } from 'app/common/components/filter-section/filter-section.component';
import { BusinessPartnersFiltersComponent } from '../../filters/business-partners-filters/business-partners-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { DatesFiltersComponent } from '../../filters/dates-filters/dates-filters.component';
import { DocumentsFiltersComponent } from '../../filters/documents-filters/documents-filters.component';
import { RoutesFiltersComponent } from '../../filters/routes-filters/routes-filters.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import BusinessPartnerGeoAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-geo/business-partner-geo.entity';
import { Validators } from '@angular/forms';
import { ExcelGeneratorService } from 'app/shared/components/excel-import/services/excel-generator.service';
import { ImportConfig } from 'app/shared/components/excel-import/interfaces/import-config.interface';
import { ImportApiResponse } from 'app/shared/components/excel-import/interfaces/import-response.interface';
import { ImportButtonComponent } from 'app/shared/components/excel-import';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { DateHelper } from 'app/utils/date.helper';


@Component({
    selector: 'app-geolocation',
    standalone: true,
    imports: [
        CommonModule,
        MatDialogModule,
        MatButtonModule,
        MatSidenavModule,
        MatFormFieldModule,
        MatPaginatorModule,
        MatIconModule,
        FormsModule,
        MatTableModule,
        MatMenuModule,
        MatSortModule,
        MatInputModule,
        TranslocoModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatDatepickerModule,
        ReactiveFormsModule,
        FilterComponent,
        DatesFiltersComponent,
        ConfigurationFiltersComponent,
        DocumentsFiltersComponent,
        RoutesFiltersComponent,
        BusinessPartnersFiltersComponent,
        FilterSectionComponent,
        StatusFiltersComponent,
        ImportButtonComponent,
        HoverMenuDirective
    ],
    templateUrl: './geolocation-pending.component.html',
    //   styleUrl: './geolocation-pending.component.scss'
    providers: [
        { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
        // BusinessPartnerExport,
        // BusinessPartnerAddressExport,
        // BusinessPartnerByOneAddressExport
    ],
})
export class GeolocationComponent implements OnDestroy {

    getCode = getCode;
    displayedColumns: string[] = [
        // "addresses",
        "name",
        "type",
        "geo",
        "division",
        "createdAt"
    ];

    dataSource: BusinessPartnerGeoAttributes[] = [];
    companyList: CompanyAttributes[] = [];

    searchQuery: string = "";
    totalItems: number = 0;
    pageSize: number = 50;
    pageIndex: number = 1;

    selectedTypeCodes: string[] = [];
    selectedCompanyIds: string[] = [];
    geolocationFilter: "both" | "not_registered" | "valid" = "both";


    fileToUpload: File | null = null;
    excelData: any[] = []; // Datos del Excel
    displayedColumnsPreview: string[] = []; // Columnas de la tabla
    aux_file = false; // Tu variable existente
    //   dialogRefAdd: MatDialogRef<any>;
    //   dialogRefEdit:MatDialogRef<any>;

    statusAnuladas = false;  // Corresponde a 0
    statusActivas = false;   // Corresponde a 1

    // Valor que se enviará (0, 1 o null)
    selectedStatus: boolean | null = null;

    range = new FormGroup({
        start: new FormControl<Date | null>(new Date()),
        end: new FormControl<Date | null>(new Date()),
    });

    @ViewChild(MatSort) sort!: MatSort;
    @ViewChild(MatPaginator) paginator!: MatPaginator;
    @ViewChild('hiddenfileinput', { static: false }) hiddenfileinput!: ElementRef<HTMLInputElement>;
    @ViewChild("corfimDialog") confirmDialog!: TemplateRef<any>;

    //BUSCADOR
    searchSubscription: Subscription;

    form: FormGroup;

    //Para filtros
    selectedStatuses: number[] = [];

    loadRoutesData = false;

    constructor(
        private businessPartnerService: BusinessPartnerService,
        private dialog: MatDialog,
        private readonly addressService: BusinessPartnerAddressService,
        private readonly searchService: SearchService,
        private snackBar: MatSnackBar,
        private fb: FormBuilder,
        private excelGeneratorService: ExcelGeneratorService,
    ) {
        const today = new Date();
        this.form = this.fb.group({
        start: [today],
        end: [today],
        companyId: [],
        salesOfficeId: [],
        subRouteId: [],
        payingBusinessPartnerId: [],
        receivingBusinessPartnerId: [],
        soldToControl: [],
        searchReceivingBusinessPartner: [],
        searchAssignedUser: [],
        });
    }

    onRoutesExpanded(): void {
        this.loadRoutesData = true;
    }

    ngOnInit() {
        this.onHandleSearch();
    }

    ngAfterViewInit() {
        this.setupPaginationAndSorting
        this.findAllWithCount();
    }

    private setupPaginationAndSorting(): void {
        this.paginator.page.subscribe(() => this.findAllWithCount());
        this.sort.sortChange.subscribe(() => {
            this.paginator.pageIndex = 0;
            this.findAllWithCount();
        });
    }

    findAllWithCount(): void {
        // const pageIndex = this.paginator.pageIndex ;
        const sortField = this.getSortField();
        const sortDirection: "ASC" | "DESC" =
            this.sort.direction === "asc" ? "ASC" : "DESC";

        const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);

        let status: boolean = true;

        let allStatus: boolean = true;

        if(this.selectedStatuses.length === 0){
            allStatus = false;
            status = null;
        }else{
            if(this.selectedStatuses.length >1){
                allStatus = false;
                status = null;
            }
            if(this.selectedStatuses[0] === 0) status = false;
        }

        let dataFilter = {
            typesCodes: this.selectedTypeCodes,
            flagBusinessPartner: false,
            status: status,
            routesId: this.form.get("subRouteId")?.value,
            start: DateHelper.getStartOfDay(this.form.get("start")?.value),
            end: DateHelper.getEndOfDay(this.form.get("end")?.value) ?? DateHelper.getEndOfDay(this.form.get("start")?.value) ?? null,
            allStatus: allStatus
        }

        this.businessPartnerService
            .findAllWithCountByGeoUpdate(
                {
                    currentPage: this.pageIndex,
                    limitPerPage: this.pageSize,
                    search: this.searchQuery,
                    sort: sortField,
                    sortDirection: sortDirection,
                },
                dataFilter
            )
            .subscribe((data) => {
                this.dataSource = data?.data?.[0]?.data ?? [];
                this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
                this.paginator.length = this.totalItems;
            });
    }

    getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
        return selectedCompanyIds.map(
            (id) => this.companyList.find((group) => group._id.toString() === id)?.id
        );
    }

    private getSortField(): keyof BusinessPartnerGeoAttributes {
        const validSortFields: (keyof BusinessPartnerGeoAttributes)[] = [
            "id",
            "name",
        ];
        return validSortFields.includes(
            this.sort.active as keyof BusinessPartnerGeoAttributes
        )
            ? (this.sort.active as keyof BusinessPartnerGeoAttributes)
            : "id";
    }


    onPageChange(event: PageEvent): void {
        this.pageSize = event.pageSize;
        this.pageIndex = event.pageIndex + 1;
        this.findAllWithCount();
    }

    onSearchChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        this.searchQuery = input.value.trim();
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
            // this.paginator.pageIndex = 1 ;
            this.findAllWithCount();
        }
    }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      });
  }

    trackByFn(index: number, item: BusinessPartnerAttributes): string {
        return item._id.toString();
    }

    exportToExcel(): void {
        const dialogRef = this.dialog.open(GeoComponent, {
            width: "600px",
            disableClose: true,
        });
        dialogRef.afterClosed().subscribe((result) => {
            if (result) {
            }
        });
    }

    async handleFileInput(event: any) {
        this.resetPreview();
        this.aux_file = true;
        this.fileToUpload = event.target.files[0];

        if (this.fileToUpload) {
            if (this.fileToUpload.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
                this.snackBar.open("Ingrese solo archivos de tipo .xlsx", "Cerrar", { duration: 3000 });
                this.resetPreview();
                return;
            }

            await this.readExcelWithExcelJS(this.fileToUpload);
        } else {
            this.aux_file = false;
            this.resetPreview();
        }
    }
    async readExcelWithExcelJS(file: File) {
        try {
            const arrayBuffer = await file.arrayBuffer();
            const workbook = new Workbook();
            await workbook.xlsx.load(arrayBuffer);

            const worksheet = workbook.worksheets[0];
            this.excelData = [];
            this.displayedColumnsPreview = [];

            const headerRow = worksheet.getRow(1);
            headerRow.eachCell((cell) => {
                this.displayedColumnsPreview.push(cell.text);
            });

            worksheet.eachRow((row, rowNumber) => {
                if (rowNumber === 1) return;

                const rowData: any = {};
                row.eachCell((cell, colNumber) => {
                    rowData[this.displayedColumnsPreview[colNumber - 1]] = cell.text;
                });
                this.excelData.push(rowData);
            });

            this.openPreviewModal();
        } catch (error) {
            this.snackBar.open('Error al procesar el archivo', 'Cerrar', {
                duration: 3000,
            });
            this.resetPreview();
        }
    }

    resetPreview() {
        this.excelData = [];
        this.displayedColumnsPreview = [];
    }

    openPreviewModal() {
        const dialogRef = this.dialog.open(PreviewExcelModalComponent, {
            width: '80%',
            data: {
                excelData: this.excelData,
                displayedColumns: this.displayedColumnsPreview
            },
            disableClose: true,
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.confirmImportWithValidation(result);
            } else {
                this.resetFileInput(this.hiddenfileinput.nativeElement);
                this.resetPreview();
            }
        });
    }

    resetFileInput(fileInput: HTMLInputElement) {
        if (fileInput) {
            fileInput.value = '';
        } else if (this.hiddenfileinput?.nativeElement) {
            this.hiddenfileinput.nativeElement.value = '';
        }
        this.fileToUpload = null;
        this.aux_file = false;
        this.excelData = [];
        this.displayedColumnsPreview = [];
    }

    confirmImportWithValidation(data: any) {
        if (data.totalErrors > 0) {
            const confirmDialog = this.dialog.open(this.confirmDialog, {
                data: {
                    title: 'Confirmar Importación',
                    message: 'Existen registros con campos faltantes. ¿Desea continuar?',
                    confirmText: 'Importar',
                    cancelText: 'Revisar nuevamente'
                }
            });

            confirmDialog.afterClosed().subscribe(confirmed => {
                if (confirmed) {
                    this.processImport(data.data);
                }
            });
        } else {
            this.processImport(data.data);
        }
    }

    processImport(data: any[], fileInput?: HTMLInputElement) {

        const cleanData = data
            .filter(item => item._isValid)
            .map(item => {
                const { _errors, _isValid, ...rest } = item;
                return rest;
            });

        const formData = new FormData();
        formData.append('file', this.fileToUpload);
        formData.append('validatedData', JSON.stringify(cleanData));
        const serviceCall = this.addressService.saveImportAddressFile(formData);

        serviceCall.subscribe({
            next: (res: any) => {
                this.snackBar.open(res.message, "Cerrar", { duration: 3000 });
                this.resetFileInput(fileInput);
                this.findAllWithCount();
            },
            error: (err) => {
                this.snackBar.open(err?.error?.message || 'Error al subir el archivo', 'Cerrar', { duration: 3000 });
                this.resetFileInput(fileInput);
                this.findAllWithCount();
            },
        });
    }

    updateStatus(status: number, isChecked: boolean): void {
        if (status === 0) {
            this.statusAnuladas = isChecked;
        } else if (status === 1) {
            this.statusActivas = isChecked;
        }

        if (this.statusAnuladas && !this.statusActivas) {
            this.selectedStatus = false;
        } else if (!this.statusAnuladas && this.statusActivas) {
            this.selectedStatus = true;
        } else {
            this.selectedStatus = null;
        }
    }

    onClearFilter() {
        this.selectedStatuses = [];
        this.form.reset();
        this.onFilter()
    }

    onFilter() {
        this.range.valueChanges.subscribe((rangeValues) => {
            this.range.value.start = rangeValues.start || this.range.value.start;
            this.range.value.end = rangeValues.end || this.range.value.end;
        });

        this.findAllWithCount()
    }

    ngOnDestroy(): void {
        this.searchSubscription.unsubscribe();
    }

    customImportHandler = async (data: any[], metadata?: any): Promise<ImportApiResponse> => {
      try {
        // Generate Excel file from validated data
        const fileName = metadata?.fileName || 'geolocation_import.xlsx';
        const sheetName = metadata?.sheetName || 'Datos GPS';
  
        const excelFile = await this.excelGeneratorService.generateExcelFile(
          data,
          this.importConfig.columns,
          fileName,
          sheetName
        );
  
  
        // Create FormData to match the existing service expectation
        const formData = new FormData();
  
        // Add the generated Excel file (this is what the API expects)
        formData.append('file', excelFile, fileName);
  
        // Add the validated data as JSON for backend processing
        formData.append('validatedData', JSON.stringify(data));
  
        // Add metadata if available
        if (metadata) {
          formData.append('metadata', JSON.stringify(metadata));
        }
  
        // Use the existing service method
        const response: any = await this.addressService.saveImportAddressFile(formData).toPromise();

        this.findAllWithCount();
  
        // Transform the response to match ImportApiResponse format
        return {
          success: response?.processedResult?.errorCount === 0 ? true : false,
          data: response?.data,
          totalProcessed: data.length,
          totalSuccess: response?.processedResult?.successCount,
          totalFailed: response?.processedResult?.errorCount,
          errors: response?.processedResult?.errors || [],
          message: response?.message || 'Importación completada exitosamente',
        };
      } catch (error: any) {
        this.snackBar.open(error.error.message || 'Fallo la importación.',"Cerrar",{ duration: 5000});
  
        // Handle API errors and transform them to ImportApiResponse format
        const errorMessage =
          error?.error?.message || error?.message || 'Error durante la importación';
        const apiErrors = error?.error?.errors || [];
  
        return {
          success: false,
          totalProcessed: data.length,
          totalSuccess: 0,
          totalFailed: data.length,
          errors: apiErrors.map((err: any, index: number) => ({
            row: err.row || index,
            column: err.field || err.column || 'general',
            message: err.message || errorMessage,
            severity: 'error' as const,
          })),
          message: errorMessage,
        };
      }
    };
  

    importConfig: ImportConfig = {
      title: 'de actualización gps',
      columns: [
        {
          key: 'codigo',
          displayName: 'Código',
          required: true,
          dataType: 'string',
          excelColumnName: 'Código',
          validation: [Validators.required, Validators.minLength(1), Validators.maxLength(20)],
        },
        {
          key: 'nombre',
          displayName: 'Nombre',
          required: false,
          dataType: 'string',
          excelColumnName: 'Nombre',
          validation: [Validators.maxLength(100)],
        },
        {
          key: 'codigo_direccion',
          displayName: 'Código Dirección',
          required: true,
          dataType: 'string',
          excelColumnName: 'Código Dirección',
          validation: [Validators.required, Validators.minLength(1), Validators.maxLength(20)],
        },
        {
          key: 'direccion',
          displayName: 'Dirección',
          required: false,
          dataType: 'string',
          excelColumnName: 'Dirección',
          validation: [Validators.maxLength(255)],
        },
        {
          key: 'latitud',
          displayName: 'Latitud',
          required: false,
          dataType: 'number',
          excelColumnName: 'Latitud',
          validation: [Validators.min(-90), Validators.max(90)],
        },
        {
          key: 'longitud',
          displayName: 'Longitud',
          required: false,
          dataType: 'number',
          excelColumnName: 'Longitud',
          validation: [Validators.min(-180), Validators.max(180)],
        },
        {
          key: 'codigo_ruta',
          displayName: 'Código Ruta',
          required: true,
          dataType: 'string',
          excelColumnName: 'Código Ruta',
          validation: [Validators.required, Validators.minLength(1), Validators.maxLength(20)],
        },
        {
          key: 'nombre_ruta',
          displayName: 'Nombre Ruta',
          required: false,
          dataType: 'string',
          excelColumnName: 'Nombre Ruta',
          validation: [Validators.maxLength(100)],
        },
      ],
      apiEndpoint: '/api/business_partner_address/upload/update-geolocation',
      customImportHandler: this.customImportHandler,
      allowReUpload: true,
      maxFileSize: 5 * 1024 * 1024, // 5MB
      acceptedFileTypes: ['.xlsx', '.xls'],
  }
}
